import InView from './in-view'

export default {
  InView
}
